import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Employee, IEmployee } from 'cm-angular-org-chart/lib/employee';
import { IIndiceRemissivo, IPermissao, IPersmissaoSelect } from '../permissao';
import { PerfisService } from '../perfis.service';
import { IIncluirPerfilDto } from '../model/interfaces-perfil';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { IUsuarioArmazenamentoLocal } from '../model/usuario-sso-model';
import { Router } from '@angular/router';
import { animate } from '@angular/animations';

@Component({
  selector: 'app-criar-perfil',
  templateUrl: './criar-perfil.component.html',
  styleUrls: ['./criar-perfil.component.scss'],
})
export class CriarPerfilComponent implements OnInit, AfterViewInit {
  usuario!: IUsuarioArmazenamentoLocal;
  permissoesAcessoUsuario!: Array<number>;

  modoVisualizacao = 'novo';

  numeroMenu = 0;
  mostrarArvoreSelecionada = false;
  arvoreOriginal: any = {};
  arvoreSendoMostrada: any = null;

  alphabet: string[] = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  indiceRemissivo: IIndiceRemissivo[] = [];
  indiceRemissivoFiltrado: IIndiceRemissivo[] = [];

  menuSendoMostrado: any = null;
  menuPrincipal: any = {};

  selecoes: IPersmissaoSelect[] = [];
  mensagens: string[] | [] = [];
  statusSucesso: string | 'alert-success' = 'alert-success';
  nomePerfil: string = '';

  permissoesSelecionadas: IPermissao[] = [];

  private classeMarcado = 'oc-me';
  private classeDesmarcado = 'oc-junior';
  perfilEnviado: boolean = false;

  menulinha1: boolean = false;
  menulinha2: boolean = false;
  menulinha3: boolean = false;

  constructor(
    @Inject(Router) private router: Router,
    private service: PerfisService,
    private snackBar: SnackBarService
  ) {
    this.getDadosUsuario();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.verificarArvoreSelecionada();
    }, 1000);
  }

  formatarCaminhoLongo(p: IPersmissaoSelect): string {
    return this.service.formatarCaminho(p, this.usuario.guid);
  }

  getDadosUsuario() {
    try {
      this.service.getUsuarioLocalStorage().subscribe((r) => {
        this.usuario = r;
        this.permissoesAcessoUsuario = r.permissoes.map(
          (p) => p.codigoPermissao
        );
        this.permissoesAcessoUsuario = [...this.permissoesAcessoUsuario, 0];
      });
    } catch {
      this.statusSucesso = 'alert-danger';
      this.mensagens = ['Erro nos dados de consulta do usuário!'];
    }
  }

  filtarIndiceRemissivoPodCodAcesso(): void {}

  verificarArvoreSelecionada() {
    var sel = Array.from(document.querySelectorAll('.oc-designation'));
    var idsSelecionados = this.permissoesSelecionadas.map((p) => p.id);

    idsSelecionados.forEach((id) => {
      const elem = sel.find((el: Element) => {
        el.innerHTML == id;
      });
      if (elem !== undefined) {
        var jaSelecionado = elem.parentNode?.parentNode?.querySelector(
          '.selecionado'
        ) as Element;

        if (!jaSelecionado) {
          var pai = elem.parentNode?.parentElement;
          let nelem = document.createElement('div');
          nelem.classList.add('selecionado');
          nelem.style.height = '15px';
          nelem.style.width = '15px';
          nelem.style.backgroundColor = '#80ADD0';
          nelem.style.borderRadius = '50%';
          nelem.style.marginRight = '5px';
          nelem.style.border = '#fff solid 2px';
          pai?.prepend(elem);
        }
      }
    });

    sel.forEach((el: Element) => {
      let id = el.innerHTML;

      if (idsSelecionados.includes(id)) {
        var jaSelecionado = el.parentNode?.parentNode?.querySelector(
          '.selecionado'
        ) as Element;

        if (!jaSelecionado) {
          var pai = el.parentNode?.parentElement;
          let elem = document.createElement('div');
          elem.classList.add('selecionado');
          elem.style.height = '15px';
          elem.style.width = '15px';
          elem.style.backgroundColor = '#80ADD0';
          elem.style.borderRadius = '50%';
          elem.style.marginRight = '5px';
          elem.style.border = '#fff solid 2px';
          pai?.prepend(elem);
        }
      }
    });
  }

  addRemoverMarcacaoSelecionado(designation: string, adicionar = false) {
    // console.log('addRemoverMarcacaoSelecionado', designation, adicionar);
    var sel = Array.from(document.querySelectorAll('.oc-designation'));

    sel.forEach((el: Element) => {
      if (el.innerHTML == designation) {
        var jaSelecionado = el.parentNode?.parentNode?.querySelector(
          '.selecionado'
        ) as Element;

        if (!adicionar && jaSelecionado) {
          jaSelecionado?.remove();
        } else if (adicionar && !jaSelecionado) {
          var pai = el.parentNode?.parentElement;
          let elem = document.createElement('div');
          elem.classList.add('selecionado');
          elem.style.height = '15px';
          elem.style.width = '15px';
          elem.style.backgroundColor = '#80ADD0';
          elem.style.borderRadius = '50%';
          elem.style.marginRight = '5px';
          elem.style.border = '#fff solid 2px';
          pai?.prepend(elem);
        }
      }
    });
  }

  alterarVisualizacao(modo: string): void {
    this.selecoes = [];
    this.permissoesSelecionadas = [];
    this.indiceRemissivo = [];
    this.indiceRemissivoFiltrado = [];
    this.buscarXmls();
    this.modoVisualizacao = modo;
  }

  mostrarPrimeiraLinhaDeMenus() {
    this.menuSendoMostrado.subordinates.map((t: any) => (t.subordinates = []));
  }

  gerenciarNivelExibicao() {

    try {
      this.menulinha1 =
      this.menuPrincipal.subordinates[0].designation == 108;
    this.menulinha2 =
      this.menuPrincipal.subordinates[1].designation == 109;
    this.menulinha3 =
      this.menuPrincipal.subordinates[2].designation > 2;
    } catch (error) {
   
    }
 
  }

  eliminarDescendentes(menu: any) {
    // console.log(menu)
     menu.subordinates.forEach((s:any) => {
      s.subordinates = null;
     });
     return menu;

  }

  trocarArvoreSendoExibida(arvore: Event) {
    this.alterarVisualizacao('tradicional');
    var arvoreEscolhida = arvore.target as HTMLSelectElement;
    var idArvoreEscolhida = arvoreEscolhida?.name;

    // console.log(this.menuPrincipal.subordinates)

    this.mostrarArvoreSelecionada = false;

    if (this.menulinha1 && idArvoreEscolhida == 'menu1') {
      this.numeroMenu = 0;
      this.menuSendoMostrado = JSON.parse(
        JSON.stringify(
          this.eliminarDescendentes(this.menuPrincipal.subordinates[this.numeroMenu])
        )
      );
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.menuPrincipal.subordinates[this.numeroMenu]
        )
      );
    }

    if (this.menulinha2 && idArvoreEscolhida == 'menu2') {
      this.numeroMenu = 1;
      this.menuSendoMostrado = JSON.parse(
        JSON.stringify(
          this.eliminarDescendentes(this.menuPrincipal.subordinates[this.numeroMenu])
        )
      );
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.menuPrincipal.subordinates[this.numeroMenu]
        )
      );
    }

    if (this.menulinha3 && idArvoreEscolhida == 'menu3') {
      this.numeroMenu = 2;
      this.menuSendoMostrado = JSON.parse(
        JSON.stringify(
          this.eliminarDescendentes(this.menuPrincipal.subordinates[this.numeroMenu])
        )
      );
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.menuPrincipal.subordinates[this.numeroMenu]
        )
      );
    }

    this.mostrarPrimeiraLinhaDeMenus();
    return;
  }

  marcarDesmarcarSubordinados(
    e: IEmployee,
    marcar: string,
    icone: string,
    permissao: boolean
  ) {
    e.cssClass = marcar;
    e.imageUrl = e.imageUrl;
    this.ajustarPermissoesSelecionadas(e, permissao);
    if (e.designation)
      this.addRemoverMarcacaoSelecionado(e.designation, permissao);

    if (e.subordinates.length > 0) {
      e.subordinates.forEach((subordinado: any) => {
        this.marcarDesmarcarSubordinados(subordinado, marcar, icone, permissao);
      });
    }
  }

  ajustarPermissoesSelecionadas(e: any, adicionar: boolean = true) {
    let p: IPermissao;
    p = { id: e.designation, nome: e.name, url: e.dscUrl };

    this.permissoesSelecionadas = this.permissoesSelecionadas.filter(
      (p) => p.id !== e.designation
    );

    if (adicionar) this.permissoesSelecionadas.push(p);
  }

  findAncestors(tree: IEmployee, designation: string): IEmployee[] {
    if (tree.designation === designation) {
      return [tree];
    }

    if (tree.subordinates != undefined) {
      for (const subordinate of tree.subordinates) {
        const ancestors = this.findAncestors(subordinate, designation);
        if (ancestors.length > 0) {
          return [tree, ...ancestors];
        }
      }
    }

    return [];
  }

  onClickItemE(e: Employee) {
    var id = e.designation || '';
    var antecessores = this.findAncestors(this.arvoreSendoMostrada, id);
    let addPermissao = true;

    if (e.cssClass === this.classeMarcado) {
      e.cssClass = this.classeDesmarcado;
      addPermissao = false;
    } else {
      e.cssClass = this.classeMarcado;
    }

    e.subordinates.forEach((subordinado: any) => {
      if (subordinado.designation)
        this.marcarDesmarcarSubordinados(
          subordinado,
          e.cssClass,
          e.imageUrl,
          addPermissao
        );
    });

    if (e.cssClass !== this.classeDesmarcado) {
      var c = antecessores.filter((a) => a.designation !== id);
      c.forEach((antecessor) => {
        if (antecessor.designation)
          this.addRemoverMarcacaoSelecionado(
            antecessor.designation,
            addPermissao
          );

        antecessor.cssClass = e.cssClass;
        antecessor.imageUrl = e.imageUrl;
        this.ajustarPermissoesSelecionadas(antecessor, addPermissao);
      });
    }

    if (e.designation)
      this.addRemoverMarcacaoSelecionado(e.designation, addPermissao);
    this.ajustarPermissoesSelecionadas(e, addPermissao);
  }

  oreganizarSelecoes(item: IPersmissaoSelect) {
    this.selecoes = this.selecoes.filter((s) => s.ids !== item.ids);

    if (item.selecionado) {
      this.selecoes.push(item);
    }
  }

  marcarComoSelecionado(arg0: any) {
    let marcado = arg0.selecionado;
    let ids = arg0.ids;
    const ultimoValor = ids[ids.length - 1];

    this.indiceRemissivo.forEach((ind) => {
      ind.permissoes.forEach((item) => {
        let s = item.ids[item.ids.length - 1];

        if (marcado) {
          if (ids.includes(s)) {
            item.selecionado = marcado;
            this.oreganizarSelecoes(item);
          }
        }

        if ((item.ids as number[]).includes(ultimoValor)) {
          item.selecionado = marcado;
          this.oreganizarSelecoes(item);
        }
      });
    });

    this.indiceRemissivoFiltrado.forEach((ind) => {
      ind.permissoes.forEach((item) => {
        let s = item.ids[item.ids.length - 1];

        if (marcado) {
          if (ids.includes(s)) {
            item.selecionado = marcado;
          }
        }

        if ((item.ids as number[]).includes(ultimoValor)) {
          item.selecionado = marcado;
        }
      });
    });
  }

  mostrarSequencia(e: IEmployee) {

    // this.arvoreSendoMostrada = JSON.parse(
    //   JSON.stringify(this.menuPrincipal.subordinates[0].subordinates[this.numeroMenu -1].subordinates[e.designation || 1])
    // );
    if (this.menulinha1 && ! this.menulinha2) {
      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.menuPrincipal.subordinates[this.numeroMenu].subordinates.find(
            (t: any) => t.designation === e.designation
          ) || null
        )
      );
    } else {
      // console.log('mostarSequencia', e.designation, e.name, this.numeroMenu);
      // console.log(this.menuPrincipal.subordinates[this.numeroMenu].subordinates);

      this.arvoreSendoMostrada = JSON.parse(
        JSON.stringify(
          this.menuPrincipal.subordinates[this.numeroMenu].subordinates.find((t: any) => t.designation === e.designation) ||
            null
        )
      );
    }

    // console.log(this.arvoreSendoMostrada);
    this.mostrarArvoreSelecionada = true;

    setTimeout(() => {
      this.verificarArvoreSelecionada();
    }, 20);
  }

  parseNode(node: Element): any {
    const obj: any = {};
    //const attributes = node.attributes;
    const designation = parseInt(node.getAttribute('Cod_Permissao') || '-1');
    const indPrivado = node.getAttribute('Ind_Privado');
    const dscPermissao = node.getAttribute('Dsc_Permissao');
    const dscObjeto = node.getAttribute('Dsc_Objeto');
    const name = node.getAttribute('Dsc_Permissao');
    const dscUrl = node.getAttribute('Dsc_URL');
    const tipo = parseInt(node.getAttribute('tipo') || '-1');

    if (
      [-1, 3].includes(tipo) ||
      [-1, 3].includes(designation) ||
      !this.permissoesAcessoUsuario.includes(designation)
    ) {
      // console.log('Permissão não permitida: ', designation, dscPermissao);
      // console.log('Tipo: ', this.permissoesAcessoUsuario.includes(parseInt(designation)));
      // console.log(this.permissoesAcessoUsuario.filter(x=> x > 940))
      return null;
    }

    obj.designation = designation;
    obj.indPrivado = indPrivado;
    obj.dscPermissao = dscPermissao;
    obj.dscObjeto = dscObjeto;
    obj.name = name;
    obj.dscUrl = dscUrl;
    obj.tipo = tipo;
    obj.cssClass = 'oc-junior';

    obj.subordinates = [];

    const childNodes = node.childNodes;

    for (let i = 0; i < childNodes.length; i++) {
      const childNode = childNodes[i];

      if (childNode.nodeType === Node.ELEMENT_NODE) {
        var r = this.parseNode(childNode as Element);
        if (r !== null) {
          obj.subordinates.push(r);
        }
      }
    }

    return obj;
  }
  convertXmlToJson(xml: string): void {
    const xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
    const json: any[] = [];
    const rootNodes = xmlDoc.getElementsByTagName('Permissao');
    json.push(this.parseNode(rootNodes[0]));

    this.menuPrincipal = json[0];
    this.arvoreOriginal = JSON.parse(JSON.stringify(json[0]));

    this.gerenciarNivelExibicao();
  }

  createMapping(xml: string): IPersmissaoSelect[] {
    const xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
    const mapping: any[] = [];

    function traverse(
      node: Element,
      path: any[],
      ids: any[],
      permissoesAcessoUsuario: Array<number>
    ) {
      var codPermissao = parseInt(node.getAttribute('Cod_Permissao') || '-1');
      var tipo = parseInt(node.getAttribute('tipo') || '-1');

      let obj: IPersmissaoSelect = {
        nomePermissao: node.getAttribute('Dsc_Permissao'),
        url: node.getAttribute('Dsc_URL'),
        caminho: [...path, node.getAttribute('Dsc_Permissao')],
        ids: [...ids, codPermissao],
        selecionado: false,
      };

      // Verificar se o tipo é diferente de 3 e -1 e se o código da permissão está na lista de permissões do usuário
      if (
        ![-1, 3].includes(tipo) &&
        ![-1, 3].includes(codPermissao) &&
        permissoesAcessoUsuario.includes(codPermissao)
      )
        mapping.push(obj);

      const children = node.children;
      for (let i = 0; i < children.length; i++) {
        traverse(
          children[i],
          [...path, node.getAttribute('Dsc_Permissao')],
          [...ids, parseInt(node.getAttribute('Cod_Permissao') || '0')],
          permissoesAcessoUsuario
        );
      }
    }

    traverse(xmlDoc.documentElement, [], [], this.permissoesAcessoUsuario);

    return mapping;
  }

  searchObjects(filtro: string) {
    if (filtro.trim() !== '') {
      const searchResults: IIndiceRemissivo[] = [];
      this.indiceRemissivo.forEach((obj) => {
        const filteredPermissoes = obj.permissoes.filter((p) =>
          this.removeAccents(p.nomePermissao)
            .toLowerCase()
            .includes(this.removeAccents(filtro.trim()).toLowerCase())
        );

        if (filteredPermissoes.length > 0) {
          const newObj: IIndiceRemissivo = {
            letra: obj.letra,
            permissoes: filteredPermissoes,
          };

          searchResults.push(newObj);
        }
      });
      this.indiceRemissivoFiltrado = JSON.parse(JSON.stringify(searchResults));
    } else
      this.indiceRemissivoFiltrado = JSON.parse(
        JSON.stringify(this.indiceRemissivo)
      );
  }

  removeAccents(nomePermissao: string | null): string {
    if (nomePermissao === null) return '';
    return nomePermissao.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  salvarPerfil(): void {
    let lstPermissoes: number[] = [];

    this.selecoes.forEach((s) => {
      s.ids.forEach((id) => {
        lstPermissoes.includes(id) ? null : lstPermissoes.push(id);
      });
    });

    this.permissoesSelecionadas.forEach((p) => {
      if (p.id !== null)
        lstPermissoes.includes(parseInt(p.id))
          ? null
          : lstPermissoes.push(parseInt(p.id));
    });

    lstPermissoes = lstPermissoes.filter((x) => x != 0);

    let incluirPerfilDto: IIncluirPerfilDto = {
      dscLogin: this.usuario.login,
      lstPermissoes: lstPermissoes,
      dscperfil: this.nomePerfil,
    };

    this.perfilEnviado = true;
    this.service
      .criarPerfil(incluirPerfilDto, this.usuario.guid)
      .subscribe((r) => {
        if (r.sucesso) {
          this.mensagens = [r.retorno?.erro || 'Perfil criado com sucesso!'];
          this.statusSucesso = 'alert-success';
          setTimeout(() => {
            this.selecoes = [];
            this.permissoesSelecionadas = [];
            this.router.navigateByUrl(''); // retorna a lista de perfis
          }, 3000);
        } else {
          this.mensagens = r.mensagens;
          this.statusSucesso = 'alert-danger';
        }
        this.perfilEnviado = false;
      });
  }

  buscarXmls(): void {
    this.service.getPerfis(this.usuario).subscribe((p) => {
      if (p.length === 0) return;
      let decoded = this.service.fromBinary(p.fileContents); // "✓ à la mode"
      this.convertXmlToJson(decoded);

      var res = this.createMapping(decoded);

      this.alphabet.forEach((letra) => {
        var l: IIndiceRemissivo = { letra: letra, permissoes: [] };
        l.permissoes = res.filter((p) => p.nomePermissao?.startsWith(letra));

        this.indiceRemissivo.push(l);
      });
      this.searchObjects('');
    });
    /*
    this.service.getPerfis(this.usuario, "_tratado").subscribe((p) => {
      let decoded = this.service.fromBinary(p.fileContents) // "✓ à la mode"

      var res = this.createMapping(decoded);


      this.alphabet.forEach((letra) => {
        var l: IIndiceRemissivo = { letra: letra, permissoes: [] };
        l.permissoes = res.filter((p) => p.nomePermissao?.startsWith(letra));


        this.indiceRemissivo.push(l);
      });
      this.searchObjects('');
    });
    */
  }

  ngOnInit(): void {
    this.buscarXmls();
  }

  protected readonly length = length;
}
